import { PaymentFileDatabaseSchema } from 'cesg-shared/dist/models';
import { appHttpService } from '../standard/http-service';

interface PaymentFileRequestBody {
  invoicesIds: string[];
  requestPaymentDate: string;
}

class PaymentFileService {
  async createPaymentFile(
    body: PaymentFileRequestBody,
  ): Promise<{ blob: Blob; paymentFileId: string; paymentFileName: string }> {
    const response = await appHttpService.request
      .url(`/paymentfile`)
      .post(body)
      .res();

    const blob = await response.blob();
    const paymentFileName =
      response.headers.get('X-Payment-File-Name') ?? 'betalfil.xml';
    const paymentFileId = response.headers.get('X-Payment-File-Id') ?? '';

    return { blob, paymentFileId, paymentFileName };
  }

  async submitPaymentFile(
    paymentFileId: string,
  ): Promise<typeof PaymentFileDatabaseSchema> {
    return await appHttpService.request
      .url(`/paymentfile/submit/${paymentFileId}`)
      .put()
      .json<typeof PaymentFileDatabaseSchema>();
  }

  async unSubmitPaymentFile(
    paymentFileId: string,
  ): Promise<typeof PaymentFileDatabaseSchema> {
    return await appHttpService.request
      .url(`/paymentfile/unsubmit/${paymentFileId}`)
      .put()
      .json<typeof PaymentFileDatabaseSchema>();
  }

  async getPaymentFile(
    paymentFileId: string,
  ): Promise<{
    blob: Blob;
    paymentFileId: string;
    paymentFileName: string;
    supplierInvoiceIds: string[];
  }> {
    const response = await appHttpService.request
      .url(`/paymentfile/${paymentFileId}`)
      .get()
      .res();

    const data = (await response.json()) as {
      fileBlob: string;
      fileName: string;
      supplierInvoiceIds: string[];
    };

    const supplierInvoiceIds = data.supplierInvoiceIds;
    const paymentFileName = data.fileName ?? `${paymentFileId}-betalfil.xml`;
    const blob = new Blob([data.fileBlob], { type: 'application/xml' });

    return { blob, paymentFileId, paymentFileName, supplierInvoiceIds };
  }
}

export const paymentFileService = new PaymentFileService();
